module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "kayak_badge.a7c8f5bf.png";